import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { Box } from '@mui/material';
import { red } from '@mui/material/colors';

const ColumnChartThree = () => {
  const rawData = [
    [1000, 500, 1000, 500, 1000, 500, 1000, 500],
    [500, 30, 700, 500, 300, 100, 900, 377],
  ];

  const totalData: number[] = [];
  for (let i = 0; i < rawData[0].length; ++i) {
    let sum = 0;
    for (let j = 0; j < rawData.length; ++j) {
      sum += rawData[j][i];
    }
    totalData.push(sum);
  }
  
  var series = [
 
    {
      data: [45, 46, 100,45, 200, 100],
      type: 'bar',
      stack: 'b',
      name: 'Vencido',
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: 'rgba(224, 74, 76, 1)',
      },
      label: {
        show: true,
        position: 'top',
        fontWeight: ['bold'],
        padding: [5, 10],
        borderRadius: [5],
      }
    },
    {
      name: 'Temperature',
      type: 'line',
      yAxisIndex: 1,
      formatter: (params: { value: number }) => Math.round(params.value),
      lineStyle: {
        color: 'black',
        width: 4,
      
      },
      data: [45, 46, 100,45, 200, 100],
    },
  ];

  const option = {
    title: {
      text: 'Contas a receber por data de vencimento',
      textStyle: {
        fontSize: '14px'
      }
    },
    legend: {
      data: ['Pago', 'Vencido'],
      right: '0',
    },
    yAxis: [{
      type: 'value',
    },{
      axisLabel: {
        formatter: ''
      }
    }],
    xAxis: {
      type: 'category',
    },
    series,
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ColumnChartThree;
